// src/theme/colors.js
export const COLORS = {
  // Primary Brand Colors - Elegant Red
  primary: '#C62828',      // Rich elegant red
  primaryDark: '#8E0000',  // Darker deep red
  primaryLight: '#EF5350', // Lighter vibrant red
  primaryGradient: 'linear-gradient(135deg, #C62828 0%, #E53935 100%)',
  
  // Secondary Accent Colors
  secondary: '#E53935',    // Bright red
  secondaryDark: '#B71C1C', // Dark red
  secondaryLight: '#FF8A80', // Soft pink-red
  
  // Neutral Colors
  background: '#fafafa',
  white: '#ffffff',
  black: '#1a1a1a',
  
  // Status Colors
  error: '#d32f2f',
  success: '#2e7d32',
  warning: '#f57c00',
  info: '#1976d2',
  
  // Text Colors
  text: {
    primary: '#1a1a1a',
    secondary: '#666666',
    light: '#999999',
    white: '#ffffff',
    muted: 'rgba(0, 0, 0, 0.6)',
  },
  
  // Shadow
  shadow: 'rgba(0,0,0,0.1)',
  shadowDark: 'rgba(0,0,0,0.2)',
  shadowRed: 'rgba(198, 40, 40, 0.3)',
  
  // Border
  border: '#e0e0e0',
  borderLight: '#f0f0f0',
  borderRed: 'rgba(198, 40, 40, 0.2)',
  
  // Background Gradients
  gradients: {
    primary: 'linear-gradient(135deg, #C62828 0%, #E53935 100%)',
    primaryDark: 'linear-gradient(135deg, #8E0000 0%, #C62828 100%)',
    primaryLight: 'linear-gradient(135deg, #E53935 0%, #FF8A80 100%)',
    redToPink: 'linear-gradient(135deg, #C62828 0%, #EF5350 50%, #FF8A80 100%)',
    darkToRed: 'linear-gradient(135deg, #1a1a1a 0%, #C62828 100%)',
  },
  
  // Red Variants
  red: {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    950: '#8e0000',
  },
  
  // Opacity Variants
  opacity: {
    primary: 'rgba(198, 40, 40, 0.1)',
    primaryLight: 'rgba(198, 40, 40, 0.2)',
    primaryMedium: 'rgba(198, 40, 40, 0.4)',
    primaryDark: 'rgba(198, 40, 40, 0.6)',
    primaryHeavy: 'rgba(198, 40, 40, 0.8)',
  },
};

export const BRAND = {
  name: 'Elegante',
  tagline: 'Luxury Style & Elegance',
  description: 'Premium Lounge Experience',
  year: new Date().getFullYear(),
  colors: {
    primary: '#C62828',
    secondary: '#E53935',
    accent: '#EF5350',
    dark: '#8E0000',
    light: '#FF8A80',
  },
  fonts: {
    primary: "'Playfair Display', 'Georgia', serif",
    secondary: "'Montserrat', 'Helvetica', sans-serif",
  },
};